import axios, { AxiosInstance, AxiosResponse, CancelTokenStatic } from "axios";
import { getApiBaseUrl } from "@/services/api-config";

export const client: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
});

export const CancelToken: CancelTokenStatic = axios.CancelToken;

export function initInterceptors(onError: (_: any) => Promise<never>): void {
  client.interceptors.response.use((response: AxiosResponse) => response.data, onError);
}

export async function httpGet<T>(url: string): Promise<T> {
  return (await client.get(url)) as unknown as T;
}

export async function httpPost<T>(url: string, data: any): Promise<T> {
  return (await client.post(url, data)) as unknown as T;
}

export async function httpPut<T>(url: string, data: any): Promise<T> {
  return (await client.put(url, data)) as unknown as T;
}
